import { Grid, useMediaQuery } from '@material-ui/core';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import formatters from '../../../../Core/Grid/inputFormatter';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import DialogComp from '../../../../Core/Modal/dialogModal';
import EditIcon from '@material-ui/icons/Edit';
import AddUpdateStatusColorModal from './addUpdateStatusColorModal';
import ReactDOM from 'react-dom';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Sales', active: true },
    { name: 'Colours', active: true }
];

const baseColumns = [
    { field: 'action', title: `Action`, width: '5%', filterable: false, sortable: false },
    { field: 'description', title: `Colour Description`, sortable: true }
];

const StatusColorScreen = (props) => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedSalesEwipStatusID: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedSalesEwipStatusID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };
    const baseColumns = [
        { field: 'action', title: `Action`, width: '5%', filterable: false, sortable: false },
        { field: 'description', title: `Description`, sortable: true }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedSalesEwipStatusID: row ? row.id : null
        }));
    };
    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <abbr title="Add">
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <abbr title="Edit">
                    {' '}
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    const rowDataStyle = (record) => {
        return {
            ['background-color']: record.bgColor || 'white'
        };
    };
    const colDataStyle = (record) => {
        return {
            ['color']: record.foreColor || 'black'
        };
    };

    const baseUrl = 'SalesEwipStatus';
    // console.log(state.selectedSalesEwipStatusID, 'selectedSalesEwipStatusID');
    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data?.list,
                            total: res?.data?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                        setRowStyleOnCondition={true}
                        setRowStyleFunction={rowDataStyle}
                        setColStyleOnCondition={true}
                        setColStyleFunction={colDataStyle}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp
                    maxWidth="sm"
                    overflow="auto"
                    title={state.selectedSalesEwipStatusID ? 'Update Colour' : 'Add Colour'}
                    onClose={() => handleClose(false)}
                >
                    <AddUpdateStatusColorModal onClose={() => handleClose(true)} salesEwipStatusID={state.selectedSalesEwipStatusID} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default StatusColorScreen;

// const statuses = ['Unallocated', 'Allocated', 'Received', 'Collecting', 'Collected', 'Delivering', 'Delivered', 'Cancelled', 'Aborted'];
